import { render } from "./edit-client-access.vue?vue&type=template&id=3d127c52"
import script from "./edit-client-access.vue?vue&type=script&lang=js"
export * from "./edit-client-access.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__